import React from 'react';
import PropTypes from 'prop-types';

import retailerStatus from 'constants/retailerStatus';
import i18n from 'i18n';
import * as Ui from './RetailerStatusBadge.styles';

export const getRetailerStatusColor = (status, isBlocked) => {
  if (isBlocked) return '#FF3838';
  switch (status) {
    case retailerStatus.ACCEPTED:
      return '#2E7D32';
    case retailerStatus.INVITATION_PENDING:
      return '#C46A00';
    default:
      return '#9E2A2F';
  }
};

export const getRetailerStatusText = (status, isBlocked) => {
  if (isBlocked) return i18n.t('pages:retailers.blocked');

  switch (status) {
    case retailerStatus.ACCEPTED:
      return i18n.t('pages:retailers.active');
    case retailerStatus.INVITATION_PENDING:
      return i18n.t('pages:retailers.invitationPending');
    default:
      return i18n.t('pages:retailers.notInvited');
  }
};

const RetailerStatusBadge = ({ invitationStatus, isBlocked, style }) => {
  const color = getRetailerStatusColor(invitationStatus, isBlocked);
  const text = getRetailerStatusText(invitationStatus, isBlocked);

  return (
    <Ui.Badge $color={color} style={style}>
      {text}
    </Ui.Badge>
  );
};

RetailerStatusBadge.propTypes = {
  invitationStatus: PropTypes.string,
  isBlocked: PropTypes.bool,
  style: PropTypes.object,
};

export default RetailerStatusBadge;
